import { LoginsApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const loginsApi = LoginsApi({}, '/api', axiosInstance);
